export const airportFilterCategories = Object.freeze({
  TERMINAL: 'terminal',
  AMENITIES: 'amenities',
  HOURS: 'hours',
  AMENITIES_COST: 'amenitiesCost',
});

export const filterConstantValues = {
  OPEN_NOW: 'openNow',
  COMPLIMENTARY_ONLY: 'complimentaryOnly',
};
